/**
 * Contains all the code for the F6 Reveal modals for showing the video on the single
 * estate_property pages.
 *
 * TODO: Error if you open F6 reveal before YouTube loads. Maybe we have to dynamically add the reveal after it's loaded...
 */
(function($) {
    /**
     * YouTube embed functions
     * https://developers.google.com/youtube/iframe_api_reference?hl=en
     */
    // Loads the IFrame Player API code asynchronously.
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";

    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // Creates an <iframe> (and YouTube player) after the API code downloads.
    var player;
    function onYouTubeIframeAPIReady() {
        player = new YT.Player('slider-iframe');
    }

    /*
     * When video button is clicked, get the video ID (which is set as a
     * data attribute on the button) and send it to the modal iframe.
     */
    var propertyVideoModal = $('#property-video');
    var videoPlayer;
    var videoPlayer2;

    $('.js-open-video').click( function() {
        videoPlayer = new YT.Player('video-iframe', {
            videoId: $(this).data('video-id'),
            events: {
                'onReady': function( event ) {
                    videoPlayer2 = event.target;
                    propertyVideoModal.foundation('open');
                }
            }
        });
    } );

    // On modal close, pause the video if it's playing.
    propertyVideoModal.on('closed.zf.reveal', function () {
        videoPlayer2.destroy();
    });

    // On modal open, if video is paused, play it.
    propertyVideoModal.on('open.zf.reveal', function () {
        videoPlayer2.playVideo();
    });
})(jQuery);
